export default __webpack_public_path__ + "static/media/quickBooks.b66893c1.svg";